import React, { useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import CallIcon from "@mui/icons-material/Call";

function EmergencyCall() {
  const [open, setOpen] = useState(false);

  const handleOpenDialog = () => {
    setOpen(true);
  };

  const handleCloseDialog = () => {
    setOpen(false);
  };

  const handleConfirmCall = () => {
    setOpen(false);
    window.open("tel:0333");
  };

  return (
    <div>
      <Button
        variant="contained"
        color="error"
        startIcon={<CallIcon />}
        onClick={handleOpenDialog}
        sx={{ fontSize: "12px", lineHeight: "18px" }}
      >
        Call 999
      </Button>

      {/* Confirmation Dialog */}
      <Dialog
        open={open}
        onClose={handleCloseDialog}
        aria-labelledby="confirm-call-dialog-title"
        aria-describedby="confirm-call-dialog-description"
      >
        <DialogTitle id="confirm-call-dialog-title">Emergency Call</DialogTitle>
        <DialogContent>
          <DialogContentText id="confirm-call-dialog-description">
            Do you need emergency services?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} color="primary">
            No
          </Button>
          <Button onClick={handleConfirmCall} color="error" autoFocus>
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default EmergencyCall;
